import React, { useEffect, useState } from 'react';
import './CodeLoading.css';
import { Check } from 'lucide-react';

const CodeLoading = () => {
  const steps = [
    "Analyzing the question...",
    "Extracting key information...",
    "Accessing relevant knowledge...",
    "Formulating approach...",
    "Generating initial response...",
    "Refining and optimizing solution...",
    "Checking test cases for accuracy...",
    "Adding explanations and context...",
    "Finalizing response...",
  ];

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prevStep) => {
        if (prevStep < steps.length - 1) {
          return prevStep + 1;
        } else {
          clearInterval(interval);
          return prevStep;
        }
      });
    }, 800);

    return () => clearInterval(interval);
  }, [steps.length]);

  return (
    <div className="load-container">
            <div className="content-wrapper">

      <div className="steps-container">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`loading-step ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
            style={{ transform: `translateY(-${currentStep * 30}px)` }}
          >
            <div className="check-icon">
              <Check size={20} />
            </div>
            <span>{step}</span>
          </div>
        ))}
      </div>

    </div>
                  </div>

  );
};

export default CodeLoading;